<template>
    <dashboard class="technical">
        <row>
            <panel size="col-24">
                <h2 slot="title">Technical</h2>
                <p>The following settings allow for adjustments to the Spotter application or higher access to content. You can find a full list of our developer support documents below.</p>
                <div class="buttons">
                    <app-button @click="viewIT">View IT Documentation</app-button>
                    <app-button @click="viewAPI">View API Documentation</app-button>
                </div>
            </panel>
        </row>
        <row>
            <panel size="col-10">
                <h3 slot="title">Mobile App</h3>
                <app-form
                    ref="technicalForm"
                    :model="school"
                    @submit.native.prevent="submit">
                    <grid v-if="school">
                        <grid-item width="12" mobile-width="12">
                            <app-alert>The Spotter mobile app allows for students to reach out and receive support. By default this puts them in contact with our support staff, if you would like this to go to your dedicated contact instead, enter an email here.</app-alert>
                            <app-form-item label="Support Email" prop="support_email">
                                <app-input id="support_email" v-model="school.support_email"/>
                            </app-form-item>
                        </grid-item>

                        <app-form-item>
                            <app-button
                                :loading="isSaving"
                                type="primary"
                                native-type="submit"
                                size="large">Save</app-button>
                        </app-form-item>
                    </grid>
                </app-form>
            </panel>
            <panel size="col-14">
                <h3 slot="title">API Credentials</h3>
                <app-alert>To access Spotter API's you need to use an API key. You can view your available keys below.</app-alert>
                <el-table
                    :data="keys"
                    style="width: 100%"
                    empty-text="No API keys">
                    <el-table-column
                        prop="token"
                        label="Token" />
                    <el-table-column
                        prop="expiration"
                        label="Expiration"
                        width="125px" />
                </el-table>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapGetters } from 'vuex'
import School from '@/store/models/School'

export default {
    name: 'page-technical',
    head: {
        title: {
            inner: 'Technical'
        }
    },
    data() {
        return {
            isSaving: false,
            school: {},
            keys: []
        }
    },
    computed: {
        ...mapGetters(['role', 'user'])
    },
    mounted() {
        this.school = School.find(this.user.school_id)
        School.$fetchOne()
            .then(({ data }) => {
                this.school = School.$cloneOrNew(data.id)
                this.keys = this.school.api_keys
            })
    },
    methods: {
        viewIT() {
            window.Beacon('article', '5e553ab304286364bc95d2cd', { type: 'modal' })
        },
        viewAPI() {
            window.open('https://docs.spotteredu.com', '_blank')
        },
        submit() {
            this.isSaving = true
            this.school.$update().then(() => {
                this.isSaving = false
            })
        }
    }
}
</script>

<style lang="stylus">
.technical
    .buttons .app-button
        margin-right: 10px
    .app-form
        padding-top: 0px
</style>
